import { create } from 'zustand';

interface NotificationState {
	unreadNotifications: number;
	setUnreadNotificationCount: (count: number) => void;
}

export const useNotificationStore = create<NotificationState>(set => ({
	unreadNotifications: 0,
	setUnreadNotificationCount: (count: number) => set({ unreadNotifications: count })
}));
